const projectsData = [
    {
      title: "SHEYSHOP",
      image: "./ecommerce.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
    {
      title: "SHEYPIZZA",
      image: "./pizzas.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
    {
      title: "SHEYROOMS",
      image: "./hotels.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
    {
      title: "SHEYJOBS",
      image: "./jobs.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
    {
      title: "SHEYGRAM",
      image: "./socialmedia.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
    {
      title: "SHEYCARS",
      image: "./cars.svg",
      description:
        "An ecommerce application developed using react , node , redux and mongodb",
      link: "/",
    },
  ];
  
  export default projectsData;